import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { useStyles } from './LinkedSuccessfully.styles';
import successImage from 'assets/images/app_bubble-check.png';
import { PlatformLinkingProviderEntity } from '@okletsplay/core';

type LinkedSuccessfullyProps = Pick<PlatformLinkingProviderEntity, 'platformName'>;

export const LinkedSuccessfully: FC<LinkedSuccessfullyProps> = ({ platformName }) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.image}>
        <img src={successImage} alt="success-image" />
      </Box>
      <Typography className={classes.description}>
        Your {platformName} account has been successfully linked!
      </Typography>
      <Typography className={classes.info}>Get in game and have fun!</Typography>
    </Box>
  );
};
